module.exports = __webpack_public_path__ + "img/support_jy_04@2x.64d9b30e.png";